import { render, staticRenderFns } from "./ioRecord.vue?vue&type=template&id=661f6cb2&scoped=true&"
import script from "./ioRecord.vue?vue&type=script&lang=js&"
export * from "./ioRecord.vue?vue&type=script&lang=js&"
import style0 from "./ioRecord.vue?vue&type=style&index=0&id=661f6cb2&scoped=true&lang=css&"
import style1 from "./ioRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f6cb2",
  null
  
)

export default component.exports